import React from "react";
import { Button, Spinner } from "react-bootstrap";

const COLOR_VARIANT_MAP = {
  red: "danger",
  green: "success",
  blue: "primary",
  yellow: "warning",
  gray: "secondary",
  grey: "secondary",
};

const BOOTSTRAP_VARIANTS = new Set([
  "primary",
  "secondary",
  "success",
  "danger",
  "warning",
  "info",
  "dark",
  "light",
  "outline-primary",
  "outline-secondary",
  "outline-success",
  "outline-danger",
  "outline-warning",
  "outline-info",
  "outline-dark",
  "outline-light",
  "link",
]);

export function ActionButton({
  text,
  label,
  children,
  color,
  variant,
  onClick,
  disabled = false,
  isSubmitting = false,
  isLoading = false,
  loading = false,
  type = "button",
  icon,
  className = "",
  style,
  size,
  ...restProps
}) {
  const displayText = text || label || children || "";
  const busy = isSubmitting || isLoading || loading;

  let resolvedVariant = variant;
  const customStyle = { ...style };

  if (!resolvedVariant && color) {
    const lowerColor = String(color).toLowerCase();
    if (COLOR_VARIANT_MAP[lowerColor]) {
      resolvedVariant = COLOR_VARIANT_MAP[lowerColor];
    } else if (BOOTSTRAP_VARIANTS.has(lowerColor)) {
      resolvedVariant = lowerColor;
    } else {
      customStyle.backgroundColor = color;
      customStyle.borderColor = color;
      if (!customStyle.color) {
        customStyle.color = "#fff";
      }
    }
  }

  if (!resolvedVariant && !customStyle.backgroundColor) {
    resolvedVariant = "primary";
  }

  const combinedClassName = `commission-btn ${className}`.trim();

  return (
    <Button
      type={type}
      variant={resolvedVariant}
      onClick={onClick}
      disabled={disabled || busy}
      className={combinedClassName}
      style={customStyle}
      size={size}
      {...restProps}
    >
      {busy ? (
        <>
          <Spinner size="sm" as="span" aria-hidden="true" animation="border" />
          <span>Processing...</span>
        </>
      ) : (
        <>
          {icon}
          {displayText}
        </>
      )}
    </Button>
  );
}

export default ActionButton;
